import styled from '@emotion/styled';
import { format } from 'date-fns';
import { Css, RefreshIconLight, Responsive, TextButton } from '@/ui';
import React, { useState } from 'react';
import { Color } from '../../../styles/Color';

interface IWidgetFooter {
	refetch: () => void;
	label: string;
}

export default function WidgetFooter({ refetch, label }: IWidgetFooter) {
	const [lastUpdatedTime, setLastUpdatedTime] = useState<Date>(new Date());
	const formattedTime = format(lastUpdatedTime, 'hh:mm a');

	const onClickRefresh = () => {
		refetch();
		setLastUpdatedTime(new Date());
	};

	return (
		<WidgetFooterWrap>
			<div>Last updated: {formattedTime}</div>
			<StyledRefreshButton type="button" onClick={onClickRefresh}>
				{label} <RefreshIconLight />
			</StyledRefreshButton>
		</WidgetFooterWrap>
	);
}

const WidgetFooterWrap = styled.div`
	grid-column: span 2;

	display: flex;
	flex-direction: row;
	align-items: baseline;
	gap: ${Css.pxToRem(16)};
	margin-top: ${Css.pxToRem(16)};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		flex-direction: column;
		align-items: flex-start;
		gap: ${Css.pxToRem(4)};
	}
`;

const StyledRefreshButton = styled(TextButton)`
	cursor: pointer;
	color: ${Color.PrimaryBlue};
	font-size: ${Css.pxToRem(16)};
	font-weight: 500;
	padding: 0;

	&:hover {
		color: ${Color.PrimaryBlue};
	}

	svg {
		path {
			fill: ${Color.PrimaryBlue};
		}
	}
`;
